import {Injectable} from "@angular/core";
import {ToastController, ToastOptions} from "@ionic/angular";

export declare enum FeedbackType {
    Success = 0,
    Error = 1,
    Warning = 2,
    Info = 3,
    Custom = 4
}

export interface FeedbackShowOptions extends ToastOptions {
    onHide?: () => void;
}

@Injectable()
export class ToastService {
    constructor(
        private readonly toastCtrl: ToastController
    ) {
    }

    toastRpcError(error: any) {
      // if the error message has already been marked displayed, then just abort
      if ("displayed" in error) {
        if (error.displayed) return;
      }

      let message = "";
      if ("displayMessage" in error){
        message = error.displayMessage;
      }
      if ("code" in error && error.code == "ValidationError"){
        message = "Please fix errors";
      }
      if (!message || message.length == 0){
        message = "Unknown error has occurred"
      }
      error.displayed = true;
      this.toastError({
        message: message
      })
    }

    toastError(options: FeedbackShowOptions, delayShow: number = 0) {
        options.cssClass = "toast-error";
        options.icon = "alert";
        this.showFeedback(options, delayShow);
    }

    toastInfo(options: FeedbackShowOptions, delayShow: number = 0) {
      options.cssClass = "toast-info";
      options.icon = "info-circle";
      this.showFeedback(options, delayShow);
    }

    toastSuccess(options: FeedbackShowOptions, delayShow: number = 0) {
        options.cssClass = "toast-success";
        options.icon = "confetti";
        this.showFeedback(options, delayShow);
    }

    private showFeedback(options: FeedbackShowOptions, delayShow: number = 0) {
        const callbackHide = options.onHide;
        if (!delayShow || delayShow === 0) {
        }

        if (!options.position) {
            options.position = "top";
        }
        if (!options.duration) {
            options.duration = 3000;
        }
        if (!options.buttons) {
          options.buttons = [
            {
              text: 'Dismiss',
              role: 'cancel'
            }
          ];
        }
        let onHide = () => {
            // clearTimeout(timeout);
            if (callbackHide) {
                callbackHide();
            }
        };
        options.onHide = () => {
            if (onHide) {
                const localOnHide = onHide;
                onHide = null;
                localOnHide();
            }
        };

        this.toastCtrl.dismiss().then((obj) => {
        }).catch(() => {
        }).finally(() => {
            this.toastCtrl.create({
                message: options.message,
                duration: options.duration,
                position: options.position,
                cssClass: options.cssClass,
                buttons: options.buttons,
                icon: options.icon,
            }).then((result) => {
                result.present();
                if (options.onHide) result.onDidDismiss().then(options.onHide);
            });
        });
    }
}
